//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IEnumerableCognitoStorage } from './IEnumerableCognitoStorage';

/**
 * Simple adapter that provides a standard enumeration method for a Storage interface
 */
export class EnumerableStorage implements IEnumerableCognitoStorage {

  public static createDefault() {
    return new EnumerableStorage(localStorage);
  }

  constructor(private storage: Storage) {}

  public setItem(key: string, value: string): void {
    this.storage.setItem(key, value);
  }
  public getItem(key: string): string {
    return this.storage.getItem(key);
  }

  public removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  public clear(): void {
    this.storage.clear();
  }

  public getAllKeys(): string[] {
    return Object.keys(this.storage);
  }
}
